import { EventEmitter, Output } from '@angular/core';
import {
	Component,
	Input,
	ElementRef,
	OnInit,
	AfterViewInit
} from '@angular/core';
import { Announcement } from 'go-modules/models/announcement/announcement.service';
import { AnnouncementType } from 'go-modules/models/announcement/announcement.type';

@Component({
	selector: 'ngx-go-banner',
	templateUrl: './go-banner.component.html',
	styleUrls: ['./go-banner.component.scss'],
	standalone: false
})
export class NgxGoBannerComponent implements OnInit, AfterViewInit {
	@Input() public banner!: Announcement;
	@Output() public onClose = new EventEmitter();

	private supportedTypes: string[] = Object.values(AnnouncementType);

	constructor (private elRef: ElementRef) {}

	public ngOnInit (): void {
		if (this.banner) {
			this.checkSupportedType();
		}
	}

	public ngAfterViewInit (): void {
		if (this.banner.html) {
			const messageEl = this.elRef.nativeElement.querySelector('.message');
			if (messageEl) {
				messageEl.appendChild(this.banner.html[0]);
			}
		}
	}

	public closeBanner (): void {
		this.onClose.emit();
	}

	private checkSupportedType (): void {
		if (!this.isSupportedType(this.banner.type)) {
			throw new Error(`${this.banner.type} is not a supported type.`);
		}
	}

	// TODO: move to go-banner-helper.service.ts once that is converted to ngx
	public isSupportedType (type: string): boolean {
		return this.supportedTypes.includes(type);
	}
}
